import { View, StyleSheet, ActivityIndicator } from "react-native";
import React from "react";
import { Text } from "@ui-kitten/components";
import { useAppSelector } from "hooks/useAppSelector";
import i18n from "plugins/localization";

interface Props {
  text?: string;
  size?: number;
}

const InnerLoading: React.FC<Props> = (props) => {
  const { text = i18n.t("common.loading"), size = 36 } = props;
  const tenantThemeColor = useAppSelector(
    (state) => state.tenant.tenantThemeColor
  );
  return (
    <View
      style={[
        StyleSheet.absoluteFill,
        {
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255,255,255,0.5)",
          zIndex: 99,
        },
      ]}
    >
      <View>
        <ActivityIndicator color={tenantThemeColor} size={size} />
        <Text style={{ marginTop: 10 }}>{text}</Text>
      </View>
    </View>
  );
};

export default InnerLoading;
